<template>
  <div>
    <h1 class="page-header">{{ $t('payPayrollItemCompany.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.item_type ? record.item_type.item_type : '' }}</td>
            <td>{{ record.payroll_item ? record.payroll_item.payroll_item_name : '' }}</td>
            <td>{{ record.companies ? record.companies.map(c => c.company_name_en).join(', ') : '' }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'pay-payroll-item-company',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payPayrollItemCompany', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payPayrollItemCompany.search
      },
      set(newValue) {
        this.$store.commit('hr/payPayrollItemCompany/SET_SEARCH', newValue)
        this.$store.commit('hr/payPayrollItemCompany/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payPayrollItemCompany.itemType'),
          sortKey: 'item_type_id'
        },
        {
          name: this.$t('payPayrollItemCompany.payrollItem'),
          sortKey: 'payroll_item_id'
        },
        {
          name: this.$t('payPayrollItemCompany.companyIdList'),
          sortKey: 'company_id_list'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payPayrollItemCompany/fetch', {
          ...attributes,
          include: 'item_type',
          append: 'companies,payroll_item'
        })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    // async destroy(record) {
    //   if (await this.$confirmModal.danger('Are you sure to delete ?')) {
    //     record._deleting = true
    //     this.$store
    //       .dispatch('hr/payPayrollItemCompany/destroy', record.record_id)
    //       .then(response => {
    //         this.fetchData()
    //         this.$toasted.success(response.message)
    //         record._deleting = false
    //       })
    //       .catch(error => {
    //         this.$toasted.error(error.message)
    //         record._deleting = false
    //       })
    //   }
    // },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '400px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payPayrollItemCompany/RESET_STATE')
    next()
  }
}
</script>
